export default "__VITE_ASSET__CAoZVw95__"